i2iLightbox = new function () {
    this.elements = {};
    this.currentOptions = {};
    this.init = function () {
        container = document.createElement("div");
        background = document.createElement("div");
        modal = document.createElement("div");
        content = document.createElement("iframe");
        closeButton = document.createElement("div");
        exitPipButton = document.createElement("div");
        container.id = "i2i-lightbox";
        background.id = "i2i-lightbox-background";
        modal.id = "i2i-lightbox-modal";
        content.id = "i2i-lightbox-modal-content";
        closeButton.id = "i2i-lightbox-modal-close";
        exitPipButton.id = "i2i-lightbox-pip-button";
        if (this.isMobileOrTablet()) {
            exitPipButton.className = "touch"
        }
        closeButton.innerHTML = "X";
        content.setAttribute("allowFullscreen", "yes");
        exitPipButton.appendChild(this.svgToElement('<svg xmlns="http://www.w3.org/2000/svg" viewBox="-125 -256 1792 1792" id="fullscreen"><path d="M1283 995 928 640 1283 285 1427 429q29 31 70 14 39-17 39-59V-64q0-26-19-45-19-19-45-19h-448q-42 0-59 40-17 39 14 69L1123 125 768 480 413 125 557-19q31-30 14-69-17-40-59-40H64q-26 0-45 19-19 19-19 45v448q0 42 40 59 39 17 69-14L253 285 608 640 253 995 109 851Q90 832 64 832 52 832 40 837 0 854 0 896v448q0 26 19 45 19 19 45 19h448q42 0 59-40 17-39-14-69l-144-144 355-355 355 355-144 144q-31 30-14 69 17 40 59 40h448q26 0 45-19 19-19 19-45V896q0-42-39-59-13-5-25-5-26 0-45 19z"/></svg>'));
        closeButton.onclick = function () {
            i2iLightbox.close()
        };
        exitPipButton.onclick = function () {
            i2iLightbox.togglePip("disable")
        };
        modal.appendChild(content);
        modal.appendChild(closeButton);
        modal.appendChild(exitPipButton);
        container.appendChild(background);
        container.appendChild(modal);
        document.body.appendChild(container);
        this.elements.container = container;
        this.elements.background = background;
        this.elements.modal = modal;
        this.elements.closeButton = closeButton;
        this.elements.exitPipButton = exitPipButton;
        this.elements.content = content
    };
    this.attach = function (a, b) {
        elements = document.querySelectorAll(a);
        for (i = 0; i < elements.length; i++) {
            element = elements[i];
            if (element.tagName.toLowerCase() === "a") {
                if (b) {
                    for (option in b) {
                        switch (option) {
                            case"height":
                                element.dataset.height = b[option];
                                break;
                            case"width":
                                element.dataset.width = b[option];
                                break;
                            case"maxHeight":
                                element.dataset.maxheight = b[option];
                                break;
                            case"maxWidth":
                                element.dataset.maxwidth = b[option];
                                break;
                            case"scale":
                                element.dataset.scale = b[option];
                                break;
                            case"pip":
                                element.dataset.pip = b[option];
                                break
                        }
                    }
                }
                element.addEventListener("click", function (c) {
                    c.preventDefault();
                    linkElement = c.target;
                    while (linkElement.tagName.toLowerCase() !== "a") {
                        linkElement = linkElement.parentNode
                    }
                    i2iLightbox.open(linkElement.href, linkElement.dataset)
                })
            }
        }
    };
    this.open = function (b, a) {
        if (this.elements.container.className.indexOf("small") !== -1) {
            this.togglePip("disable")
        }
        this.loadOptions(a);
        this.elements.content.src = b;
        this.elements.container.className = "open";
        this.onopen()
    };
    this.close = function () {
        if (this.elements.container.className.indexOf("small") !== -1) {
            this.togglePip("disable")
        }
        this.elements.content.src = "";
        this.elements.container.className = "";
        document.body.style.overflow = "auto";
        this.onclose()
    };
    this.onopen = function () {
    };
    this.onclose = function () {
    };
    this.svgToElement = function (a) {
        try {
            var d = new DOMParser();
            var c = d.parseFromString(a, "text/xml");
            return c.documentElement
        } catch (b) {
            return document.createElement("div")
        }
    };
    this.isMobileOrTablet = function () {
        var a = false;
        (function (b) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(b) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(b.substr(0, 4))) {
                a = true
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return a
    };
    this.loadOptions = function (a) {
        a = a ? a : {};
        this.elements.modal.removeAttribute("style");
        this.currentOptions = a;
        if (a.width) {
            this.elements.modal.style.width = a.width
        }
        if (a.height) {
            this.elements.modal.style.height = a.height
        }
        if (a.maxWidth) {
            this.elements.modal.style.maxWidth = a.maxWidth
        }
        if (a.maxHeight) {
            this.elements.modal.style.maxHeight = a.maxHeight
        }
        if (a.scale && window.addEventListener) {
            this.resizeListner = window.addEventListener("resize", function () {
                i2iLightbox.scaleLightbox()
            });
            this.scaleLightbox()
        } else {
            if (this.resizeListner) {
                window.removeEventListener("resize", this.resizeListner)
            }
        }
        if (a.pip) {
            this.elements.background.onclick = window.onscroll = function () {
                i2iLightbox.togglePip("enable")
            }
        } else {
            document.body.style.overflow = "hidden";
            this.elements.background.onclick = function () {
                i2iLightbox.close()
            }
        }
    };
    this.togglePip = function (a) {
        if (a === "enable" && i2iLightbox.elements.container.className.indexOf("small") === -1) {
            i2iLightbox.elements.container.className += " small";
            if (i2iLightbox.currentOptions.maxwidth) {
                i2iLightbox.currentOptions.oldMaxWidth = i2iLightbox.currentOptions.maxwidth
            }
            if (window.innerWidth <= 400) {
                i2iLightbox.currentOptions.maxwidth = "15em"
            } else {
                i2iLightbox.currentOptions.maxwidth = "25em"
            }
            i2iLightbox.scaleLightbox()
        } else {
            if (a === "disable") {
                i2iLightbox.elements.container.className = i2iLightbox.elements.container.className.replace(" small", "");
                if (i2iLightbox.currentOptions.oldMaxWidth) {
                    i2iLightbox.currentOptions.maxwidth = i2iLightbox.currentOptions.oldMaxWidth;
                    delete i2iLightbox.currentOptions.oldMaxWidth
                } else {
                    delete i2iLightbox.currentOptions.maxwidth
                }
                i2iLightbox.scaleLightbox()
            }
        }
    };
    this.convertToPixels = function (a, b) {
        unit = a.replace(/[0-9]/g, "").toLowerCase().replace(".", "");
        if (unit === "em") {
            return parseFloat(getComputedStyle(this.elements.modal).fontSize) * a.replace("em", "")
        } else {
            if (unit === "%") {
                if (b === "width") {
                    return window.innerWidth * (a.replace("%", "") / 100)
                } else {
                    return window.innerHeight * (a.replace("%", "") / 100)
                }
            } else {
                return a.replace(unit, "")
            }
        }
    };
    this.scaleLightbox = function () {
        paddingOffset = this.convertToPixels("3.5em");
        baseModalWidth = this.currentOptions.width.replace("px", "");
        baseModalHeight = this.currentOptions.height.replace("px", "");
        maxWidth = window.innerWidth;
        maxHeight = window.innerHeight;
        if (this.currentOptions.maxwidth) {
            if (maxWidth > this.convertToPixels(this.currentOptions.maxwidth, "width")) {
                maxWidth = this.convertToPixels(this.currentOptions.maxwidth, "width")
            }
        }
        if (this.currentOptions.maxheight) {
            if (maxHeight > this.convertToPixels(this.currentOptions.maxheight)) {
                maxHeight = this.convertToPixels(this.currentOptions.maxheight)
            }
        }
        scale = Math.min((maxWidth - paddingOffset) / baseModalWidth, (maxHeight - paddingOffset) / baseModalHeight);
        this.elements.modal.style.width = (baseModalWidth * scale) + "px";
        this.elements.modal.style.height = (baseModalHeight * scale) + "px"
    };
    if (window.addEventListener) {
        window.addEventListener("load", function () {
            i2iLightbox.init()
        })
    } else {
        window.onload = function () {
            i2iLightbox.init()
        }
    }
};
